import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "col-lg-6 d-flex flex-column justify-content-end" }
const _hoisted_6 = { class: "toolbar mt-5" }
const _hoisted_7 = { class: "btn-group mr-1" }
const _hoisted_8 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = { class: "btn-group" }
const _hoisted_11 = {
  type: "button",
  class: "btn btn-outline-secondary dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }

import { computed, watch, onMounted, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"
    import ScenarioNavigation from '@Quest/CorporateScenarios/Components/ScenarioNavigation.vue'
    import PnlViewer from '@Quest/Pnls/Components/PnlViewer.vue'

    import { CurrencyDenomination } from '@common/types'

    import
        {
            usePnlPageQueryV1,
            useCorporateScenarioPnlQueryV1
        } from '@Quest/CorporateScenarios/queries-vue-composables'

    import type {
        CorporateScenarioPnlReadModel,
        PnlPageReadModel
    } from '@Quest/CorporateScenarios/readmodels'

    import type { PnlTemplateReadModel } from '@Quest/Pnls/readmodels'


    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PnlPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))
    const scenarioId = computed(() => String(route.params.scenarioId ?? ''))


    // ======================
    // Queries
    // ======================

    const {
        runPnlPageQueryV1,
        modelPnlPageQueryV1
    } = usePnlPageQueryV1(workspaceId, strategyId, scenarioId)

    const rm = modelPnlPageQueryV1 as Ref<PnlPageReadModel | null>
    const applyBenefitsConfidenceFactor = computed(() => rm.value?.ApplyBenefitsConfidenceFactor)
    const pnlTemplateId = computed(() => rm.value?.PnlTemplateId)
    const denomination = computed(() => rm.value?.Denomination)


    const {
        runCorporateScenarioPnlQueryV1,
        modelCorporateScenarioPnlQueryV1
    } = useCorporateScenarioPnlQueryV1(workspaceId, strategyId, scenarioId, applyBenefitsConfidenceFactor, pnlTemplateId, denomination)


    // ======================
    // Derived state
    // ======================

    const selectedPnl = computed<PnlTemplateReadModel | null>(() =>
    {
        if (!rm.value?.PnlTemplates) return null

        if (rm.value.PnlTemplateId)
        {
            return rm.value.PnlTemplates.find(a => a.Id === rm.value!.PnlTemplateId) ?? null
        }

        return rm.value.PnlTemplates.find(a => a.IsDefault === true) ?? null
    })


    // ======================
    // Behaviour
    // ======================

    function reloadPnl()
    {
        if (rm.value?.PnlTemplateId)
        {
            runCorporateScenarioPnlQueryV1()
            rm.value.Report = null
        }
    }

    function toggleBenefitsConfidenceFactor()
    {
        if (!rm.value) return
        rm.value.ApplyBenefitsConfidenceFactor = !rm.value.ApplyBenefitsConfidenceFactor
        reloadPnl()
    }

    function setDenomination(d: CurrencyDenomination)
    {
        if (!rm.value) return
        rm.value.Denomination = d
        reloadPnl()
    }

    function toggleCagrVisible()
    {
        if (!rm.value) return
        rm.value.CagrVisible = !rm.value.CagrVisible
    }

    function switchPnlTemplate(pnlId: string | null)
    {
        if (!rm.value) return
        rm.value.PnlTemplateId = pnlId
        reloadPnl()
    }

    function onScheduled()
    {
        runPnlPageQueryV1()
    }


    // ======================
    // Replace onSetModel
    // ======================

    watch(modelCorporateScenarioPnlQueryV1, (model) =>
    {
        if (model && rm.value)
        {
            const pnl = model as CorporateScenarioPnlReadModel
            rm.value.Report = pnl.Report
        }
    })


    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Enterprise Plan - P&L"
        runPnlPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "dashboard" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("small", _hoisted_4, "Enterprise Plan: " + _toDisplayString(_unref(rm).ScenarioName), 1 /* TEXT */),
              _cache[5] || (_cache[5] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "P&L", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(ScenarioNavigation, { onScheduled: onScheduled })
            ])
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn mr-1", _unref(rm).ApplyBenefitsConfidenceFactor ? 'btn-warning' : 'btn-outline-secondary']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleBenefitsConfidenceFactor()))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-regular", _unref(rm).ApplyBenefitsConfidenceFactor ? 'fa-square-check' : 'fa-square'])
                }, null, 2 /* CLASS */),
                _cache[6] || (_cache[6] = _createTextVNode(" Risk adjusted benefits ", -1 /* CACHED */))
              ], 2 /* CLASS */),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn mr-1", _unref(rm).CagrVisible ? 'btn-info' : 'btn-outline-secondary']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleCagrVisible()))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa-regular", _unref(rm).CagrVisible ? 'fa-square-check' : 'fa-square'])
                }, null, 2 /* CLASS */),
                _cache[7] || (_cache[7] = _createTextVNode(" CAGR ", -1 /* CACHED */))
              ], 2 /* CLASS */),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", _hoisted_8, _toDisplayString(_unref(rm).Denomination) + "s ", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {setDenomination('Million');})
                  }, "Millions"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {setDenomination('Thousand');})
                  }, "Thousands"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => {setDenomination('Unit');})
                  }, "Units")
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", _hoisted_11, "P&L: " + _toDisplayString(selectedPnl.value?.Name), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).PnlTemplates, (t) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "dropdown-item",
                      key: t.Id,
                      onClick: ($event: any) => (switchPnlTemplate(t.Id))
                    }, _toDisplayString(t.Name), 9 /* TEXT, PROPS */, _hoisted_13))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ])
          ]),
          (_unref(rm).Report)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(PnlViewer, {
                  readModel: _unref(rm).Report,
                  cagrVisible: _unref(rm).CagrVisible,
                  class: "mt-3"
                }, null, 8 /* PROPS */, ["readModel", "cagrVisible"])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})